export default {
    sideText: '{firstName}, hoje o Sol está retornando ao ponto em que estava no dia do seu nascimento. <strong>Feliz aniversário!</strong>',
    textBelow: 'A equipe do Astrolink te deseja saúde, paz, harmonia e que a luz do autoconhecimento continue a te guiar na sua jornada. Obrigado por caminhar com a gente.<br />Aproveite seu dia! &#10084;&#65039;'
}